/** 设备会话 equipmentData：session + localStorage 双写，避免子应用 normalize 后仅更新 local 导致配色键不一致 */

export const EQUIPMENT_DATA_SESSION_KEY = "eweadn:session:equipmentData";
export const EQUIPMENT_DATA_LEGACY_KEY = "equipmentData";

/** 同步写入 session 与 localStorage（与主应用 setEquipmentData 行为一致） */
export function writeEquipmentDataToStorages(
  data: Record<string, unknown> | object
): void {
  if (typeof window === "undefined") return;
  const json = JSON.stringify(data);
  try {
    window.sessionStorage.setItem(EQUIPMENT_DATA_SESSION_KEY, json);
  } catch {
    // ignore
  }
  try {
    window.localStorage.setItem(EQUIPMENT_DATA_LEGACY_KEY, json);
  } catch {
    // ignore
  }
}

/**
 * 合并读取 equipmentData：session 为进页快照，local 可能含华奋达 normalize 后的 VID/PID。
 * 侧栏产品图、配色实例键等应优先使用本函数，避免 X87 V2 演示模式 session/local 分叉。
 */
export function readMergedEquipmentData(): Record<string, unknown> | null {
  if (typeof window === "undefined") return null;

  let session: Record<string, unknown> | null = null;
  let local: Record<string, unknown> | null = null;

  try {
    const sessionRaw = window.sessionStorage.getItem(
      EQUIPMENT_DATA_SESSION_KEY
    );
    if (sessionRaw) {
      const parsed = JSON.parse(sessionRaw) as Record<string, unknown>;
      if (parsed && typeof parsed === "object") session = parsed;
    }
  } catch {
    // ignore
  }

  try {
    const localRaw = window.localStorage.getItem(EQUIPMENT_DATA_LEGACY_KEY);
    if (localRaw) {
      const parsed = JSON.parse(localRaw) as Record<string, unknown>;
      if (parsed && typeof parsed === "object") local = parsed;
    }
  } catch {
    // ignore
  }

  if (!session && !local) return null;
  if (!local) return session;
  if (!session) return local;

  const displayname =
    String(session.displayname ?? session.displayName ?? "").trim() ||
    String(local.displayname ?? local.displayName ?? "").trim() ||
    undefined;

  // 进内页后 session 是「当前点进的设备」权威来源；local 可能被首页固件探测等后台逻辑改写。
  // 身份字段以 session 为准，其余字段允许 local 补充（如华奋达 normalize 后的运行时字段）。
  const sessionProvider = String(session.solutionRovider ?? "").trim();
  const localProvider = String(local.solutionRovider ?? "").trim();
  const identityMismatch =
    (session.vendorId != null &&
      local.vendorId != null &&
      session.vendorId !== local.vendorId) ||
    (session.productId != null &&
      local.productId != null &&
      session.productId !== local.productId) ||
    (sessionProvider && localProvider && sessionProvider !== localProvider);

  if (identityMismatch) {
    return {
      ...local,
      ...session,
      ...(displayname ? { displayname } : {}),
    };
  }

  return {
    ...session,
    ...local,
    ...(displayname ? { displayname } : {}),
  };
}
